module.exports = __webpack_public_path__ + "img/crypto-from-genesis-to-now.94938944.png";